import { render, staticRenderFns } from "./ExtraAccesses.vue?vue&type=template&id=71f53fa2&"
import script from "./ExtraAccesses.vue?vue&type=script&lang=js&"
export * from "./ExtraAccesses.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports